import type { FastifyInstance } from 'fastify'
import { registerLoggingRoutes } from './logging.routes.js'

/**
 * Logging module for capturing client-side errors and metrics
 */
export async function registerLoggingModule(fastify: FastifyInstance): Promise<void> {
  await fastify.register(
    async (instance) => {
      await registerLoggingRoutes(instance)
    },
    { prefix: '/api/logging' }
  )
}
